import { FC, memo } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import DropdownList from './dropdown-list/dropdown-list'
import usePCWindow from 'hooks/usePCWindow'
import { useAuth } from 'store/auth/useAuth'

import { OptionIcons, Option } from 'components/webinar/webinar-with-format/data'
import { IObj } from 'constants/types/common.types'

import style from './switch-toggle-dropdown.module.scss'

interface ISwitchToggleDropdown {
  options: string[]
  selectedOption: string
  handleToggle: (option: string) => void
  disabledOptions?: IObj<boolean> | null
}

const SwitchToggleDropdown: FC<ISwitchToggleDropdown> = ({
  options,
  selectedOption,
  handleToggle,
  disabledOptions,
}: ISwitchToggleDropdown) => {
  const isPC = usePCWindow()
  const { isNotAuthorized } = useAuth()

  const isDisableOption = (item: string) => {
    if (!disabledOptions?.withArticle && item === Option.read) {
      return true
    }
    if (!disabledOptions?.withAudio && item === Option.listen) {
      return true
    }
    if (!disabledOptions?.withMoments && item === Option.keyMoments) {
      return true
    }
    return false
  }
  return (
    <div className={clsx(style.wrapper, {})}>
      <p className={style.title}>Выберите удобный формат</p>

      {isPC ? (
        options.map((option) => {
          const isActive = option === selectedOption
          return (
            <button
              type="button"
              key={option}
              className={clsx(style.option, {
                [style.optionActive]: isActive,
                [style.optionDisabled]: isDisableOption(option),
                [style.blocked]: isNotAuthorized,
              })}
              onClick={() => handleToggle(option)}
            >
              <Image {...OptionIcons[option]} className={style.icon} />
              <p>{option}</p>
            </button>
          )
        })
      ) : (
        <DropdownList
          list={options}
          handleToggle={handleToggle}
          disabledOptions={disabledOptions}
          selectedOption={selectedOption}
        />
      )}
    </div>
  )
}

export default memo(SwitchToggleDropdown)
